











































import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getUrlParam from "@/common/utils/getUrlParam";
import getActivityType from "@/common/utils/getActivityType";
import fetch from "@/common/api/fetch";

import { AxiosPromiseData, AxiosPromiseError } from "@/common/interface";
import { ShareObjectInterface, SignatureData } from "@/common/interface";
import CONFIG from "@/common/config";

import GuideMask from "@/components/common/index/GuideMask.vue";

@Component
export default class JoinFooter extends Vue {
  @Getter("openId") openId!: string;
  @Getter("uid") getterUid!: string;
  @Getter("urlUid") urlUid!: string;
  @Getter("qrCodeUrl") qrCodeUrl!: string;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("leftQuota") leftQuota!: number;
  @Getter("canPay") canPay!: boolean;
  @Getter("deadline") deadline!: number;
  @Getter("startTime") startTime!: number;
  @Getter("hasPay") hasPay!: number;
  @Getter("posterName") posterName!: string;
  @Getter("showJoinFooter") showJoinFooter!: boolean;
  @Getter("titleSection") titleSection!: string;
  @Getter("orgId") orgId!: string;
  @Getter("cancel") cancel!: boolean;

  @Action("changeUid") changeUid!: Function;
  @Action("changeJoinInfo") changeJoinInfo!: Function;
  @Action("changeJoinNumber") changeJoinNumber!: Function;
  @Action("changeLeftQuota") changeLeftQuota!: Function;
  @Action("changeShowJoinFooter") changeShowJoinFooter!: Function;
  @Action("changeRankList") changeRankList!: Function;
  @Action("changeSolitaireingList") changeSolitaireingList!: Function;

  type: string = getUrlParam("type") as string;
  show: boolean = false;
  showJoinSucc: boolean = false;

  get isActivityFinish(): boolean {
    const activityDeadline: number = this.deadline;
    const nowTimestamp: number = new Date().valueOf();
    return nowTimestamp >= activityDeadline;
  }

  handleShowJoinModal() {
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error("活动未开始");
      return;
    }
    try {
      // 群接龙没有二级页面
      if (!this.getterUid) {
        window.TDAPP.onEvent("一级活动页报名数", "微传单");
      }
    } catch (error) {
      throw new Error(error);
    }

    // 是否可以支付（有无开启支付）
    if (this.canPay || this.cancel) {
      // 未报名或者已经报名但是没有支付
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const host: string = location.host;
      const tempStr: string = env === "gray" ? "/xmpay" : "/xmpay";

      if ((!this.getterUid || (this.getterUid && this.hasPay !== 4)) && !this.cancel) {
        if (window.__wxjs_environment === "miniprogram") {
          const promoterId = getUrlParam("promoterId");
          const referralId = getUrlParam("referralId");
          const broadcastId = getUrlParam("broadcastId");
          const id = getUrlParam("id");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene =
            `openId=${
              this.openId
            }&activityId=${broadcastId}&qrCodeUrl=${
              encodeURIComponent(qrCodeUrl)
            }` +
            (promoterId ? `&promoterId=${promoterId}` : "") +
            (referralId ? `&referralId=${referralId}` : "") +
            (id ? `&id=${id}` : "");
          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-detail/index?${scene}`
          });
        } else {
          fetch.post("c/common/pay/appid", {}).then((res: AxiosPromiseData) => {
            const payAppId: string = res.data;
            const targetUrl: string =
              "https://" +
              host +
              tempStr +
              (env === "prod" || env === "gray" ? "/index.html" : "/") +
              "#/xmx_solitaire_pay?userOpenId=" +
              this.openId +
              "&broadcastId=" +
              getUrlParam("broadcastId") +
              (getUrlParam("promoterId")
                ? "&promoterId=" + getUrlParam("promoterId")
                : "") +
              (getUrlParam("referralId")
                ? "&referralId=" + getUrlParam("referralId")
                : "");

            const url: string =
              (CONFIG.shareUrl as any)[env] +
              payAppId +
              "&redirect_uri=" +
              encodeURIComponent(targetUrl) +
              (targetUrl.indexOf("?") != -1 ? "%26" : "%3F") +
              "appid%3D" +
              payAppId +
              "&response_type=code&scope=snsapi_base&state=state#wechat_redirect";

            location.href = url;
          });
        }
      } else {
        // 已报名,跳转到小程序支付结结果页面
        if (window.__wxjs_environment === "miniprogram") {
          const broadcastId = getUrlParam("broadcastId");
          const id = getUrlParam("id");
          let qrCodeUrl = this.qrCodeUrl;
          if (env === "gray") {
            qrCodeUrl = qrCodeUrl.replace("xmshow", "xmshow/gray");
          }
          const scene = `openId=${
            this.openId
          }&activityId=${broadcastId}&id=${id}&qrCodeUrl=${
           encodeURIComponent(qrCodeUrl) 
          }`;

          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-result/index?${scene}`
          });
        } else {
          const targetUrl: string =
            "https://" +
            host +
            tempStr +
            (env === "prod" || env === "gray" ? "/index.html" : "/") +
            "#/xmx_solitaire_pay_result?userOpenId=" +
            this.openId +
            "&broadcastId=" +
            getUrlParam("broadcastId");
          location.href = targetUrl;
        }
      }
    } else {
      Vue.$modal({
        ok: (
          name: string,
          phone: string,
          authCode: string,
          additionalInfo: string,
          instId?: string,
        ) => {
          this.joinActivity(name, phone, authCode, additionalInfo, instId);
        }
      });
    }
  }

  joinActivity(
    name: string,
    phone: string,
    authCode: string,
    additionalInfo: string,
    instId?: string,
  ) {
    if (this.orgId && !instId) {
      Vue.$toast.error('请选择校区');
      return null;
    }
    const data = {
      name,
      instId,
      phone,
      authCode,
      additionalInfo,
      openId: this.openId,
      activityId: getUrlParam("broadcastId")
    };
    const promoterId: string = getUrlParam("promoterId") as string;
    const referralId: string = getUrlParam("referralId") as string;
    if (promoterId) {
      (data as any).promoterId = promoterId;
    }
    if (referralId) {
      (data as any).referralId = referralId;
    }
    fetch
      .newpost("anon/solitaire/joinActivity", data)
      .then((res: AxiosPromiseData) => {
        this.changeUid({ uid: res.result });
        this.getRankList();
        this.changeJoinInfo({ name, phone, signupItemConfig: additionalInfo });
        this.changeJoinNumber(this.joinNumber + 1);
        this.changeLeftQuota(this.leftQuota - 1);
      })
      .catch((error: AxiosPromiseError) => {
        Vue.$toast.error(error.resultMsg || error.message);
      });
  }

  getRankList() {
    const param = {
      activityId: getUrlParam("broadcastId"),
      pageNo: 0,
      pageSize: 10
    };
    fetch
      .newpost("anon/solitaire/getAllApplySignIns", param)
      .then((res: AxiosPromiseData) => {
        const { total, records, hasNext } = res.result;
        this.changeRankList(records);
        this.changeSolitaireingList(records);
      });
  }

  // 显示/隐藏分享popup
  handleRedirectToSharePage() {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam("broadcastId");
    const posterName = this.posterName;
    const origin = getUrlParam("origin");
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === "ordinary") {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${this.urlUid}`
      });
    } else {
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${this.urlUid}&name=${posterName}`
      });
    }
  }
}
